import React, { useEffect } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import Auth from './Auth';
import './AuthModal.css';

const AuthModal = ({ isOpen, onClose }) => {

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Bloquea el scroll del cuerpo mientras el modal está abierto
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isOpen]);

  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="auth-modal-overlay" onClick={handleBackdropClick} />
        <Dialog.Content className="auth-modal-content" aria-label="Autenticación">
          <Dialog.Title className="visually-hidden">Autenticación</Dialog.Title>
          <Dialog.Close asChild>
            <button 
              className="auth-modal-close"
              onClick={onClose}
              aria-label="Cerrar modal"
            >
              <X size={24} />
            </button>
          </Dialog.Close>
          <Auth onClose={onClose} />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default AuthModal;